import * as petrolStationApi from '../../../api/petrol_station';
import * as field from '../field';
import * as common from '../common';
import * as profile from '../info';

export const petrolStationRefuelTankerByOperatorAction =
  () => async (dispatch, getState) => {
    let currentState = getState();
    let vMobileNumber = currentState.config.mobile;
    let result = await petrolStationApi.petrolStationRefuelTankerByOperator({
      vMobileNumber,
      vType: 'new',
    });
    if (result.status)
      dispatch(
        field.setFields([
          { data: result.data[0].list, field: 'list' },
          { data: result.data[0].details, field: 'details' },
        ]),
      );
  };

export const petrolStationRefuelTankerAction = (data) => async (dispatch , getState) => {
  dispatch(common.loadingBtnAction(true));
  await dispatch(profile.operatorProfileAction());
  let currentState = getState();
  let vFuelCarCode = currentState.field.profile.vFuelCarCode;
  const result = await petrolStationApi.petrolStationRefuelTankerAdd({...data , vFuelCarCode});
  dispatch(common.snackbarAction(true, result.message));
  dispatch(common.loadingBtnAction(false));
};

export const petrolStationRefuelTankerUpdateAction = (data) => async (dispatch) => {
  dispatch(common.loadingBtnAction(true));
  const result = await petrolStationApi.petrolStationRefuelTankerUpdate(data);
  dispatch(common.snackbarAction(true, result.message));
  dispatch(common.loadingBtnAction(false));
};

export const petrolStationListAction = () => async () => {
  let result = await petrolStationApi.petrolStationList();
  return result.status ? result.data : [];
};

export const fuelCarProbe = () => async (dispatch, getState) => {
  await dispatch(profile.operatorProfileAction());
  let currentState = getState();
  let vFuelCarCode = currentState.field.profile.vFuelCarCode;
  if (vFuelCarCode) {
    const result = await petrolStationApi.fuelCarProbe({ vFuelCarCode });
    return result.data;
  }
  return {};
};
